<template>
  <QuestTypeMoreLogo v-if="questType === questTypeEnum.more"/>
  <QuestTypeSmartLogo v-else-if="questType === questTypeEnum.smart"/>
  <QuestTypeTogetherLogo v-else-if="questType === questTypeEnum.together"/>
  <QuestTypeImpulseLogo v-else-if="questType === questTypeEnum.impulse"/>
</template>

<script>
import QuestTypeMoreLogo from "@/assets/image/icons/quest/icon-activity_beweeg_meer.svg?inline";
import QuestTypeSmartLogo from "@/assets/image/icons/quest/icon-activity_beweeg_slim.svg?inline";
import QuestTypeTogetherLogo from "@/assets/image/icons/quest/icon-activity_beweeg_samen.svg?inline";
import QuestTypeImpulseLogo from "@/assets/image/icons/quest/icon-activity_beweeg_tussendoor.svg?inline";
import { QuestTypeEnum } from "sandpiper_api";

export default {
  name: "QuestTypeIcon",
  components: { QuestTypeMoreLogo, QuestTypeSmartLogo, QuestTypeTogetherLogo, QuestTypeImpulseLogo },
  props: {
    questType: String
  },
  data()
  {
    return {
      questTypeEnum: new QuestTypeEnum()
    }
  }
}
</script>